import { computed, Ref, ref } from 'vue'
import { SortOption } from '../dtos/SortOption.dto'
import { orderBy } from 'lodash'

type PageChangeDto = {
	currentPageSize: number
	currentPage: number
}

export const useTable = (registros: Ref<any[]>) => {
	const page = ref(1)
	const pageSize = ref(10)

	const searchTerm = ref()

	const sortOptions = ref<SortOption[]>([])

	function search(registro: any) {
		if (!searchTerm.value) return registro

		return Object.values(registro)
			.toString()
			.toLocaleLowerCase()
			.includes(searchTerm.value.toLocaleLowerCase())
	}

	const firstIndex = computed(() => {
		return pageSize.value * page.value - (pageSize.value - 1)
	})

	const lastIndex = computed(() => {
		return pageSize.value * page.value > registros.value.length
			? registros.value.length
			: pageSize.value * page.value
	})

	const pageData = computed(() => {
		return orderedData.value.filter(search).slice(firstIndex.value - 1, lastIndex.value)
	})

	const entriesToDelete = ref([])

	function onPageChange({ currentPageSize, currentPage }: PageChangeDto) {
		pageSize.value = currentPageSize
		page.value = currentPage
	}

	const totalRegistries = computed(() => {
		return (searchTerm.value ? pageData.value.length : registros.value?.length) || 0
	})

	const orderedData = computed(() => {
		if (!sortOptions.value.length) return registros.value

		return orderBy(
			registros.value,
			sortOptions.value.map((sort) => sort.key),
			sortOptions.value.map((sort) => sort.direction!),
		)
	})

	function handleSort(sortOption: SortOption) {
		const index = sortOptions.value.findIndex((sort) => sort.key === sortOption.key)

		if (!sortOption.direction) {
			if (index > -1) {
				sortOptions.value = sortOptions.value.filter((_, i) => i !== index)
			}
			return
		}

		if (index > -1 && sortOption.direction) {
			sortOptions.value = sortOptions.value.map((s) => (s.key === sortOption.key ? sortOption : s))
			return
		}

		if (index < 0) {
			sortOptions.value = [...sortOptions.value, sortOption]
		}
	}

	const tablePlaceholderType = computed(() => {
		if (searchTerm.value && !pageData.value.length) return 'termNotFound'
		else if (registros.value === undefined) return 'pending'
		else if (registros?.value?.length === 0) return 'empty'
		else return ''
	})

	return {
		page,
		pageSize,
		searchTerm,
		pageData,
		entriesToDelete,
		onPageChange,
		firstIndex,
		lastIndex,
		totalRegistries,
		tablePlaceholderType,
		handleSort,
		sortOptions,
	}
}
